const state = {
  user_id: null,
  username: null,
  email: null,
}

const getters = {
  user_id (state) {
    return state.user_id;
  },
  username (state) {
    return state.username;
  },
  email (state) {
    return state.email;
  }
}
const mutations = {
  update(state, { key, value }) {
    state[key] = value;
  }
}
const actions = {
  ACTION_UPDATE ({ commit }, key_value) {
    commit('update', key_value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}